var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profile',{key:_vm.reloads,attrs:{"studentId":_vm.studentId},on:{"reload":_vm.reload}})}
var staticRenderFns = []

export { render, staticRenderFns }